import React from 'react';
import { CareTeamMemberType } from './types';

export const SelectCareTeamMemberTypeContext = React.createContext<{
    selectCareTeamMemberType: (careTeamMemberType: CareTeamMemberType | null) => void;
    areUpdatesDisabled: boolean;
}>({
    selectCareTeamMemberType: () => {},
    areUpdatesDisabled: false,
});
